import script from "./ApplicationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationView.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationView.vue?vue&type=style&index=0&id=3fdae253&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdae253"]])

export default __exports__